/* eslint-disable react/prop-types */
import React from 'react';

export default function BackIcon({ onClick }) {
  return (
    <span className="text-portal-600 cursor-pointer" onClick={onClick}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-10 w-10"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}>
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M7 16l-4-4m0 0l4-4m-4 4h18"
        />
      </svg>
    </span>
  );
}
